
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/data-grid/prompt-field",
      function () {
        return require("private-next-pages/x/api/data-grid/prompt-field.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/data-grid/prompt-field"])
      });
    }
  